<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz14-1"><a id="page_2"></a><a href="#/contents#RR_11" id="CC_11"> Wally’s Bottle of Pop Float</a></p>
<p class="tx6" id="AzW"><i> A favorite of Opie’s cool aunt. </i></p>
<p class="tx1" id="pz14-2"><span class="dcap">H</span>ere’s an easy recipe that’s a real hit with my kids. After a fresh snowfall, scoop up a big glass of fresh snow. Pour in about a half glass of Coca-Cola (cream soda’s good also). Stir and eat with a spoon. If you’re feeling really exotic, give it a squirt of chocolate syrup.</p>
<p class="tx" id="pz14-3"> Serves 1.</p>
<p class="txrr" id="pz14-4"> <i>Bob Scheib, Wally’s Service—Bradford, Ohio</i></p>
<div class="image" id="pz14-5">
<p class="ser"><img alt="images/img-14-1.jpg" id="z14-5" src="images/img-14-1.jpg"/></p>
<p class="txcc" id="pz14-6"> <i>CHECK YOUR ANTI-FREEZE?—Bob Scheib's replica of Wally's Service Station is covered from a snowfall that's perfect for making Wally's Bottle of Pop Float. The Mayberry Squad Car Rendezvous is held at this Bradford, Ohio, site each summer.</i> C<span class="small">OURTESY OF</span> A<span class="small">LBERT</span> C<span class="small">OOPER</span></p>
</div>
<div class="box" id="AtQv">
<p class="tx1a" id="pz14-7"> <i>Fill ’er up at Wally’s:</i></p>
<table id="pA7L">
<tbody id="A7L" style="vertical-align: top;">
<tr id="tr-A7L-0">
<td id="td-A7L-0-0"><p class="txtb">FLOYD:</p></td>
<td id="td-A7L-0-1">You got the best pop in town.</td>
</tr>
<tr id="tr-A7L-1">
<td id="td-A7L-1-0"><p class="txtb">WALLY:</p></td>
<td id="td-A7L-1-1">Yeah.</td>
</tr>
<tr id="tr-A7L-2">
<td id="td-A7L-2-0"><p class="txtb">FLOYD:</p></td>
<td id="td-A7L-2-1">You’ve got more variety than they’ve got at the drugstore. Oh, they’ve got cherry and orange. You’ve got just about ever . . . Say, I noticed a new one in there for Huckleberry Smash. I would’ve tried it, but I already had the cap off of this Nectarine Crush.</td>
</tr>
<tr id="tr-A7L-3">
<td id="td-A7L-3-0"><p class="txtb">WALLY:</p></td>
<td id="td-A7L-3-1">Another I’ve got you oughta try—high octane ethyl.</td>
</tr>
<tr id="tr-A7L-4">
<td id="td-A7L-4-0"><p class="txtb">FLOYD:</p></td>
<td id="td-A7L-4-1">Oh, that’s a new one, that high octane ethyl?</td>
</tr>
</tbody>
</table> </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter11.vue?738afc30